// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-orange {
    background-color: #f29c00 !important;
    color: white !important;
}

.border-orange {
    border: 2px solid #f29c00 !important;
}

.results-grid {
    margin: 5px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 5px;
}

.vote-button {
    border: none;       /* Remove border */
    background: none;   /* Remove background */
    padding: 0;         /* Remove padding */
    margin: 0;          /* Remove margin */
    transition: transform 0.2s ease;
}

.vote-button:hover {
    transform: translateY(-5px); 
}

.card-container {
    position: relative;
    text-align: center;
    margin: 0;      /* Ensure no extra margin */
    padding: 0;     /* Ensure no extra padding */
}

.card-name {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(255, 255, 255, 0.9); /* Optional: Add a background for better readability */
    margin: 0;
    padding: 2px 5px;
    font-size: 14px;
    font-weight: bold;
}

.card-image {
    display: block;
    width: 100%;   /* Ensure the image takes the full width of the container */
}`, "",{"version":3,"sources":["webpack://./src/components/Poker.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4DAA4D;IAC5D,QAAQ;AACZ;;AAEA;IACI,YAAY,QAAQ,kBAAkB;IACtC,gBAAgB,IAAI,sBAAsB;IAC1C,UAAU,UAAU,mBAAmB;IACvC,SAAS,WAAW,kBAAkB;IACtC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS,OAAO,2BAA2B;IAC3C,UAAU,MAAM,4BAA4B;AAChD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,0CAA0C,EAAE,sDAAsD;IAClG,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW,IAAI,2DAA2D;AAC9E","sourcesContent":[".bg-orange {\r\n    background-color: #f29c00 !important;\r\n    color: white !important;\r\n}\r\n\r\n.border-orange {\r\n    border: 2px solid #f29c00 !important;\r\n}\r\n\r\n.results-grid {\r\n    margin: 5px;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\r\n    gap: 5px;\r\n}\r\n\r\n.vote-button {\r\n    border: none;       /* Remove border */\r\n    background: none;   /* Remove background */\r\n    padding: 0;         /* Remove padding */\r\n    margin: 0;          /* Remove margin */\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.vote-button:hover {\r\n    transform: translateY(-5px); \r\n}\r\n\r\n.card-container {\r\n    position: relative;\r\n    text-align: center;\r\n    margin: 0;      /* Ensure no extra margin */\r\n    padding: 0;     /* Ensure no extra padding */\r\n}\r\n\r\n.card-name {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background-color: rgba(255, 255, 255, 0.9); /* Optional: Add a background for better readability */\r\n    margin: 0;\r\n    padding: 2px 5px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-image {\r\n    display: block;\r\n    width: 100%;   /* Ensure the image takes the full width of the container */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
